const ModalMixin = {
  props: {
    noCloseOnBackdrop: {
      type: Boolean,
      default: false,
    },
    noCloseOnEsc: {
      type: Boolean,
      default: false,
    },
    noBackdrop: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (!document.body.classList.contains('modal-open')) {
      document.body.classList.add('modal-open')
      const currentPaddingRight = document.body.style['padding-right'] || ''
      document.body.style['padding-right'] = '15px'
      this.$once('hook:beforeDestroy', function () {
        document.body.classList.remove('modal-open')
        document.body.style['padding-right'] = currentPaddingRight
      })
    }
    if (!this.noBackdrop && !this._existBackdropElement()) {
      const backdropEl = this.addBackdrop()
      this.$once('hook:beforeDestroy', function () {
        document.body.removeChild(backdropEl)
      })
    }
    document.addEventListener('keydown', this.keydownHandler)
    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('keydown', this.keydownHandler)
    })
  },
  methods: {
    close(e) {
      this.$emit('close', e)
    },
    handleBackgroundClick(e) {
      if (!this.noCloseOnBackdrop) {
        this.close(e)
      }
    },
    _existBackdropElement() {
      const el = document.getElementById('backdropId')
      return el && el.length > 0
    },
    keydownHandler(e) {
      if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
        if (!this.noCloseOnEsc) {
          this.close(e)
        }
      }
    },
    addBackdrop() {
      const bg = document.createElement('div')
      bg.className = 'modal-backdrop in'
      bg.id = 'backdropId'
      return document.body.appendChild(bg)
    },
  },
}

export default ModalMixin
